;
(function (document, $, window) {
    'use strict';

    /*
    $('body').addClass('preloader');

    $(window).on('load', function () {
        $('#preloader .inner').fadeOut();
        $('#preloader').delay(350).fadeOut('slow');
        $('body').delay(350).removeClass('preloader');
    });
    */


    $(document).ready(function () {

       
       
       
        $(window).scroll(function () {

            $('.a-count[data-count]').each(function () {
                var top = $(this).offset().top;

                var bot = $(window).scrollTop() + $(window).height();

                if (bot <= top || $(this).hasClass('a-animate')) {
                    return;
                }

                $(this).addClass('a-animate');

                var $this = $(this);

                jQuery({
                    Counter: 0
                }).animate({
                    Counter: $this.data('count')
                }, {
                        duration: 2000,
                        easing: 'swing',
                        step: function () {
                            $this.text(Math.ceil(this.Counter));
                        }
                    });

            });



            // ANIMATION
            $('.ar, .at, .al, .ab').each(function () {

                var top = $(this).offset().top + 150;

                var bot = $(window).scrollTop() + $(window).height();

                if (bot > top) {
                    $(this).addClass('a-animate');
                }
            });
            // ANIMATION END

            $(function () {
                $('a[data-toggle="pill"]').on('click', function (e) {
                    window.localStorage.setItem('activeTab', $(e.target).attr('href'));
                });
                var activeTab = window.localStorage.getItem('activeTab');
                if (activeTab) {
                    $('#pills-tab a[href="' + activeTab + '"]').tab('show');
                    window.localStorage.removeItem("activeTab");
                }
            });


            // NAVBAR EFFECTS
            var nav = $('#navbar');
            var top = 20;
            if ($(window).scrollTop() >= top) {

                nav.removeClass('navbar-shrink');

            } else {
                nav.addClass('navbar-shrink');
            }

        }).scroll();


        $('.nav-link').each(function () {
            if (this.href === window.location.href) {
                $(this).parent().addClass('active');
            }
        });


        $('.smooth-scroll')
            .click(function (event) {
                // On-page links
                if (location.pathname !== this.pathname) {
                    window.location.href = this.href;
                } else if (
                    location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                    location.hostname === this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    //target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 50
                        }, 1000, function () {
                            /*
                            	// Callback after animation
                            	// Must change focus!
                            	var $target = $(target);
                            	$target.focus();
                            	// Checking if the target was focused
                            	if ($target.is(':focus')) {
                            		return false;
                            	} else {
                            		// Adding tabindex for elements not focusable
                            		$target.attr('tabindex','-1');
                            		$target.focus(); // Set focus again
                            	}
                            	*/
                        });
                    }
                }
            });

        /* browser window scroll (in pixels) after which the "back to top"
        	link is shown */
        var //offset = 800,
            /* browser window scroll (in pixels) after which the "back to top"
               link opacity is reduced */
            //offset_opacity = 1200,
            //duration of the top scrolling animation (in ms)
            scrollTopDuration = 700,
            //grab the "back to top" link
            backToTop = $('.cd-top');

        //hide or show the "back to top" link
        $(window).scroll(function () {
            if ($(document).height() <= ($(this).height() + $(this).scrollTop())) {
                backToTop.addClass('cd-is-visible');
            } else {
                backToTop.removeClass('cd-is-visible cd-fade-out');
            }
        });

        //smooth scroll to top
        backToTop.on('click', function (event) {
            event.preventDefault();
            $('body,html').animate({
                scrollTop: 0,
            }, scrollTopDuration);
        });


        $('.product-link picture').on({
            mouseenter: function () {
                $('source', this).each(function (i, elem) {
                    elem.data('init-src', elem.attr('srcset'));
                    elem.attr('srcset', elem.data('alt-src'));
                });
            },
            mouseleave: function () {
                $('source', this).each(function (i, elem) {
                    elem.attr('srcset', elem.data('init-src'));
                });

            }
        });


        // SIMPLE MODAL

        document.bsSimpleModal = function (title, content, opts) {
            var defaultOptions = {
                'node': null,
                'large': false,
                'removeClassModalBody': false,
                'theme': 'primary', // bootstrap themes
                'buttonCaption': 'OK',
                'redirect': null
            };
            opts = opts ? $.extend(true, defaultOptions, opts) : defaultOptions;

            var footerButtons = '';
            if (opts.node && opts.node.data('cta-title')) {
                footerButtons = '<a role="button" class="cta btn btn-' + opts.theme + '">' +
                    opts.node.data('cta-title') + '</a>';
            } else {

                footerButtons = '<button type="button" class="btn btn-' + opts.theme +
                    '" data-dismiss="modal">' + opts.buttonCaption + '</button>';

            }

            var modal = $('<div class="modal" tabindex="-1" role="dialog">' +
                '<div class="modal-dialog' + (opts.large ? ' modal-lg' : '') + '" role="document">' +
                '<div class="modal-content">' +
                '<div class="modal-header">' +
                '<h5 class="modal-title"></h5>' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Fechar">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                '</div>' +
                '<div class="' + (opts.removeClassModalBody ? '' : 'modal-body') +
                ' modal-body-html">' +
                '</div>' +
                '<div class="modal-footer">' + footerButtons + '</div>' +
                '</div>' +
                '</div>' +
                '</div>');
            if (opts.node) {
                modal.find('.modal-footer .cta').attr({
                    'onclick': opts.node.data('cta-onclick'),
                    'href': opts.node.data('cta-url'),
                    'target': opts.node.data('cta-target')
                });
            }
            modal.appendTo(document.body);
            modal.on('hidden.bs.modal', function () {
                modal.remove();
                if (opts.redirect) {
                    window.location.href = opts.redirect;
                }
            });
            modal.find('.modal-title').html(title);
            modal.find('.modal-body-html').html(content);
            modal.modal('show');
        };


        // ------- BEGIN AJAX FORM --------
        $('form.ajax-form .form-control').blur(function () {
            $(this).parent().addClass('was-validated');
        });

        $('form.ajax-form').on('submit', function (event) {
            var $form = $(this),
                form = $form[0];
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                $form.addClass('was-validated');
            } else {
                var data = new FormData(form);
                data.set('ajax', '1');

                gApp.call($form.attr('method'), $form.attr('action'), data, function (json, oReq) {
                    if (oReq.status === 200 && json && json.data === 'OK') {
                        $form.removeClass('was-validated')
                            .find('.was-validated')
                            .removeClass('was-validated');
                        form.reset();

                        if ($form.data('modal-success-content')) {
                            document.bsSimpleModal(
                                $form.data('modal-success-title'),
                                $form.data('modal-success-content'), {
                                    'theme': 'success',
                                    'redirect': $form.data('modal-success-redirect')
                                }
                            );
                        }
                        return;
                    }
                    if ($form.data('modal-error-content')) {
                        var html;
                        if (json && json.message) {
                            html = $form.data('modal-error-server-content').replace('%s', json.message);
                        } else {
                            html = $form.data('modal-error-content');
                        }
                        document.bsSimpleModal(
                            $form.data('modal-error-title'),
                            html, {
                                'theme': 'danger',
                                'redirect': $form.data('modal-error-redirect')
                            }
                        );
                    }
                });

                event.preventDefault();
                event.stopPropagation();
            }
        });
        // end form.ajax-form submit

        // ------- END AJAX FORM --------


        $('.navbar-toggler').click(function () {
            if ($(this).hasClass('collapsed')) {
                $('.content-blur').addClass('blur-5');
                $('.navbar').addClass('navbar-100vh');
                $('document,body').addClass('overflow-hidden');
            } else {
                $('.content-blur').removeClass('blur-5');
                $('.navbar').removeClass('navbar-100vh');
                $('document,body').removeClass('overflow-hidden');
            }
        });
    });



})(document, jQuery, window);
